import Styles from './VcmModalConfirm.module.scss'
import { Button } from '../Button'
import { Modal, StackModalProps } from 'almanac-ui/Modal'

export interface Props extends StackModalProps {
  onCancel: () => void
  onConfirm: () => void
  onPressOutside: () => void
}

export const FolderVcmModalConfirm = ({ onCancel, onConfirm, onPressOutside }: Props) => (
  <Modal.Root onPressOutside={onPressOutside}>
    <Modal.Header title="By turning on Version Control Mode:" />
    <Modal.Content>
      <ul className={Styles.list}>
        <li className={Styles.listItem}>Edits to all docs in this folder must be merged in using layers.</li>
        <li className={Styles.listItem}>
          Users with read and comment access can suggest changes on a layer, but editors must approve and merge them in.
        </li>
        <li className={Styles.listItem}>Any new reviews will start on a layer.</li>
        <li className={Styles.listItem}>All outstanding tracked changes will be accepted.</li>
      </ul>
    </Modal.Content>
    <Modal.Footer>
      <Modal.FooterContent slot="left">
        <Button onPress={onCancel} size="xl" variant="tertiary">
          Cancel
        </Button>
      </Modal.FooterContent>
      <Modal.FooterContent slot="right">
        <Button onPress={onConfirm} size="xl" variant="primary">
          Confirm
        </Button>
      </Modal.FooterContent>
    </Modal.Footer>
  </Modal.Root>
)
